<template>
  <div class="categorii-panel">
    <div class="categorii-header">
      <i class="dx-icon dx-icon-tags" style="font-size:18px;margin-right:8px;opacity:0.9" />
      <div class="header-text">
        <span class="panel-title">Categorii</span>
        <span v-if="ClasaNume" class="panel-subtitle">{{ ClasaNume }}</span>
      </div>
    </div>

    <div class="categorii-grid-container">
    <DxDataGrid ref="dataGridRef" :data-source="dsCategorii" key-expr="ID" :remote-operations="true"
      @row-click="onRowClick" :focused-row-enabled="true" :focused-row-key="focusedRowKey"
      :onRowRemoving="onRowRemoving" :show-row-lines="true" :hover-state-enabled="true"
      :show-borders="false" :show-column-lines="false" :row-alternation-enabled="false"
      height="100%">
      <DxStateStoring :enabled="true" storage-key="grid-pro-categorii-state" type="localStorage" />
      <DxColumnChooser :enabled="true" />
      <DxSearchPanel :visible="true" placeholder="Caută..." />
      <DxSelection mode="none" />
      <DxFilterRow :visible="true" />
      <DxPaging :page-size="20" :page-index="1" />
      <DxLoadPanel :enabled="true" :indicator-src="'reload6.gif'" />
      <DxSorting mode="multiple" />
      <DxToolbar>
        <DxItemForm name="searchPanel" location="before" />
        <DxItem location="after">
          <template #default>
            <DxButton icon="add" @click="onAddClick" />
          </template>
        </DxItem>
        <DxItem location="after">
          <template #default>
            <DxButton icon="refresh" @click="onRefreshClick" />
          </template>
        </DxItem>
        <DxItemForm name="columnChooserButton" location="after" />
      </DxToolbar>
      <DxEditing :allowUpdating="true" :allowDeleting="true" mode="popup">
        <DxPopup :closeOnOutsideClick="false" :showCloseButton="false" :width="600" :height="580">
          <DxToolbarItem :template="customTitleTemplate" />
          <DxToolbarItem toolbar="bottom" widget="dxButton" location="after" :options="successButtonOptions" />
          <DxToolbarItem toolbar="bottom" widget="dxButton" location="after" :options="dangerButtonOptions" />
        </DxPopup>
        <DxFormGrid :col-span="1" :col-count="1" item-type="group">
          <DxItemForm data-field="Nume" :editor-options="{ width: 560 }" />
          <DxItemForm :col-span="2" :col-count="2" item-type="group">
            <DxItemForm data-field="Cod" />
            <DxItemForm data-field="JurnalCodInternId" editor-type="dxSelectBox" :editor-options="{
              dataSource: dsCodIntern,
              valueExpr: 'ID',
              displayExpr: 'Cod',
              placeholder: 'Selectează',
            }" :label="{ text: 'Jurnal Cod Intern' }" />
            <DxItemForm data-field="ClasaId" :visible="false" :editor-options="{
              dataSource: dsClase,
              displayExpr: 'Id',
              valueExpr: 'ClasaID'
            }" />
            <DxItemForm data-field="WwwID" :editor-options="{ showSpinButtons: true }"
              editor-type="dxNumberBox" />
            <DxItemForm data-field="WwwSyncedDate" editor-type="dxDateBox"
              :editor-options="{ type: 'datetime', displayFormat: 'yyyy-MM-dd HH:mm' }" />
          </DxItemForm>
          <DxItemForm data-field="CategorieContabilaDefaultId" editor-type="dxSelectBox" :editor-options="{
            dataSource: dsCategoriiContabile,
            valueExpr: 'Id',
            displayExpr: 'Nume',
            placeholder: 'Selectează',
          }" :label="{ text: 'Categorie Contabilă' }" />
          <DxItemForm :col-span="4" :col-count="4" item-type="group">
            <DxItemForm data-field="Client" editor-type="dxSwitch" />
            <DxItemForm data-field="Furnizor" editor-type="dxSwitch" />
            <DxItemForm data-field="Editabil" editor-type="dxSwitch" />
            <DxItemForm data-field="MateriePrima" editor-type="dxSwitch" />
          </DxItemForm>
          <DxItemForm data-field="Explicatie" :editor-options="{ width: 560, height: 100 }" />
        </DxFormGrid>
      </DxEditing>
      <DxColumn data-field="Cod" />
      <DxColumn data-field="Nume" />
      <DxColumn data-field="Client" :allow-search="false" />
      <DxColumn data-field="Furnizor" :allow-search="false" />
      <DxColumn data-field="Editabil" :allow-search="false" />
      <DxColumn data-field="CategorieContabilaDefaultId" caption="Categorie Contabilă" :allow-search="false" :lookup="{
        dataSource: dsCategoriiContabile,
        valueExpr: 'Id',
        displayExpr: 'Nume'
      }" />
      <DxColumn data-field="MateriePrima" :allow-search="false" />
      <DxColumn data-field="JurnalCodInternId" caption="Jurnal Cod Intern" :allow-search="false" :lookup="{
        dataSource: dsCodIntern,
        valueExpr: 'ID',
        displayExpr: 'Cod'
      }" />
      <DxColumn data-field="ClasaId" caption="Clasa" :allow-search="false" :lookup="{
        dataSource: dsClase,
        valueExpr: 'ID',
        displayExpr: 'NumeArborescent'
      }" />
      <DxColumn data-field="WwwID" :visible="false" />
      <DxColumn data-field="WwwSyncedDate" :visible="false" />
      <DxColumn data-field="Explicatie" :visible="false" />
    </DxDataGrid>
    </div>

    <DxPopupAdd v-model:visible="isModalVisible" :closeOnOutsideClick="false" :showCloseButton="false" :showTitle="true"
      :width="600" :height="580">
      <template #title>
        <div style="background: linear-gradient(90deg, #ff2c21, #ff6a4a); font-size:15px; color:white; font-weight:bold; padding:12px 20px;">
          Adăugare Categorie
        </div>
      </template>
      <div>
        <DxForm>
          <DxItem data-field="Nume" :editor-options="{
            value: formData.Nume,
            onValueChanged: e => formData.Nume = e.value
          }" />
          <DxItem :col-span="2" :col-count="2" item-type="group">
            <DxItem data-field="Cod" :editor-options="{
              value: formData.Cod,
              onValueChanged: e => formData.Cod = e.value
            }" />
            <DxItem data-field="JurnalCodInternId" editor-type="dxSelectBox" :editor-options="{
              value: formData.JurnalCodInternId,
              onValueChanged: e => formData.JurnalCodInternId = e.value,
              dataSource: dsCodIntern,
              valueExpr: 'ID',
              displayExpr: 'Cod',
              showClearButton: true,
              placeholder: 'ex: Selectează'
            }" :label="{ text: 'Jurnal Cod Intern' }" />
            <DxItem data-field="ClasaId" :visible="false" :editor-options="{
              dataSource: dsClase,
              displayExpr: 'Id',
              valueExpr: 'ClasaID'
            }" />
            <DxItem data-field="WwwID" :editor-options="{
              showSpinButtons: true, value: formData.WwwID,
              onValueChanged: e => formData.WwwID = e.value
            }" editor-type="dxNumberBox" />
            <DxItem data-field="WwwSyncedDate" editor-type="dxDateBox" :editor-options="{
              type: 'datetime', displayFormat: 'yyyy-MM-dd HH:mm', value: formData.WwwSyncedDate,
              onValueChanged: e => formData.WwwSyncedDate = e.value
            }" />
          </DxItem>
          <DxItem data-field="CategorieContabilaDefaultId" editor-type="dxSelectBox" :editor-options="{
            dataSource: dsCategoriiContabile,
            valueExpr: 'Id',
            displayExpr: 'Nume',
            showClearButton: true,
            width: 560,
            placeholder: 'ex: Selectează',
            value: formData.CategorieContabilaDefaultId,
            onValueChanged: e => formData.CategorieContabilaDefaultId = e.value
          }" :label="{ text: 'Categorie Contabilă' }" />
          <DxItem :col-span="4" :col-count="4" item-type="group">
            <DxItem data-field="Client" editor-type="dxSwitch" :editor-options="{
              value: formData.Client,
              onValueChanged: e => formData.Client = e.value
            }" />
            <DxItem data-field="Furnizor" editor-type="dxSwitch" :editor-options="{
              value: formData.Furnizor,
              onValueChanged: e => formData.Furnizor = e.value
            }" />
            <DxItem data-field="Editabil" editor-type="dxSwitch" :editor-options="{
              value: formData.Editabil,
              onValueChanged: e => formData.Editabil = e.value
            }" />
            <DxItem data-field="MateriePrima" editor-type="dxSwitch" :editor-options="{
              value: formData.MateriePrima,
              onValueChanged: e => formData.MateriePrima = e.value
            }" />
          </DxItem>
          <DxItem data-field="Explicatie" :editor-options="{
            width: 560, height: 100, value: formData.Explicatie,
            onValueChanged: e => formData.Explicatie = e.value
          }" />
        </DxForm>
        <div style="display:flex;justify-content:flex-end;gap:8px;margin-top:25px;">
          <DxButton text="Salvează" type="success" width="100" @click="onSaveAdd" />
          <DxButton text="Închide" type="danger" width="100" @click="onCancel" />
        </div>
      </div>
    </DxPopupAdd>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, markRaw } from 'vue';
import { locale, loadMessages } from 'devextreme/localization';
import { DxButton } from 'devextreme-vue/button';
import DxPopupAdd, { DxToolbarItem } from 'devextreme-vue/popup';
import { DxItem, DxForm, DxLabel } from 'devextreme-vue/form';
import {
  DxColumn,
  DxDataGrid,
  DxFilterRow,
  DxLoadPanel,
  DxPaging,
  DxSelection,
  DxSorting,
  DxStateStoring,
  DxToolbar,
  DxEditing,
  DxPopup,
  DxItem as DxItemForm,
  DxForm as DxFormGrid,
  DxValidationRule,
  DxRequiredRule,
  DxSearchPanel,
  DxColumnChooser,
} from 'devextreme-vue/data-grid';
import 'devextreme/dist/css/dx.light.css';
import 'devextreme/dist/css/dx.common.css';
import ODataStore from 'devextreme/data/odata/store';
import AppSetting from '@/settings/appSettings';
import notify from 'devextreme/ui/notify';
import { DxLookup } from 'devextreme-vue';
import PRO_Categorii from '@/services/PRO/PRO_Categorii';
export default defineComponent({
  components: {
    DxToolbar,
    DxDataGrid,
    DxColumn,
    DxSorting,
    DxSelection,
    DxFilterRow,
    DxStateStoring,
    DxLoadPanel,
    DxPaging,
    DxButton,
    DxItem,
    DxPopup,
    DxForm,
    DxLabel,
    DxEditing,
    DxPopupAdd,
    DxToolbarItem,
    DxItemForm,
    DxFormGrid,
    DxValidationRule,
    DxRequiredRule,
    DxLookup,
    DxSearchPanel,
    DxColumnChooser,
  },
  props: {
    ClasaID: String,
    ClasaNume: String,
  },
  watch: {
    ClasaID: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal !== oldVal || oldVal === undefined) {
          this.createODataContext(newVal);
        }
      }
    }
  },
  data() {
    return {
      dsCategorii: {} as ODataStore,
      dsCategoriiContabile: {} as ODataStore,
      dsCodIntern: {} as ODataStore,
      dsClase: {} as ODataStore,
      deleteConfirmationMessage: "Sigur doriți să ștergeți această înregistrare?",
      isModalVisible: false,
      formData: {
        Cod: '',
        Nume: '',
        Client: false,
        Furnizor: false,
        Editabil: false,
        CategorieContabilaDefaultId: null,
        JurnalCodInternId: null,
        ClasaID: '',
        UserCreare: '',
        DataCreare: null,
        UserModificare: '',
        DataModificare: null,
        MateriePrima: false,
        WwwID: null,
        WwwSyncedDate: null,
        Explicatie: '',
      },
      dataGridRef: ref<DxDataGrid | null>(null),
      focusedRowKey: null as string | null,
      successButtonOptions: {
        type: 'success',
        stylingMode: 'contained',
        text: 'Salvează',
        onClick: () => { this.onSaveEdit(); },
      },
      dangerButtonOptions: {
        type: 'danger',
        stylingMode: 'contained',
        text: 'Închide',
        onClick: () => { this.onCancelEdit(); },
      },
      customTitleTemplate() {
        return `
          <div style="background: linear-gradient(90deg, #ff2c21, #ff6a4a); font-size: 15px; float: right; height:47px; width:665px; color: white;
          font-weight: bold; padding: 12px; padding-right: 450px; position: relative; left: 30px;">
            Editare Categorie
          </div>
        `;
      },
    };
  },
  methods: {
    createODataContext(ClasaID) {
      const categorieId = this.$route.query.CategorieId as string;
      this.focusedRowKey = categorieId || null;

      const headers = () => ({
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('ERA_Jwt'),
      });
      this.dsCategorii = markRaw({
        store: new ODataStore({
          url: AppSetting.API_Url_ComercialOdata + 'PRO_Categorii',
          key: 'Id',
          version: 4,
          fieldTypes: { ClasaID: 'Guid', Id: 'Guid' },
          beforeSend: e => {
            e.headers = headers();
            e.params.$expand = [
              'CategorieContabilaDefault($select=Nume)',
              'JurnalCodIntern($select=Cod)',
              'Clasa($select=Nume)'
            ];
          },
        }),
        filter: ['ClasaID', '=', ClasaID]
      });
      this.dsCategoriiContabile = markRaw(new ODataStore({
        url: AppSetting.API_Url_ComercialOdata + 'CON_CategoriiContabile',
        key: 'Id',
        version: 4,
        beforeSend: e => { e.headers = headers(); }
      }));
      this.dsCodIntern = markRaw(new ODataStore({
        url: AppSetting.API_Url_ComercialOdata + 'PRO_CodIntern',
        key: 'ID',
        version: 4,
        beforeSend: e => { e.headers = headers(); }
      }));
      this.dsClase = markRaw(new ODataStore({
        url: AppSetting.API_Url_ComercialOdata + 'PRO_Clase',
        key: 'Id',
        version: 4,
        beforeSend: e => { e.headers = headers(); }
      }));
    },
    onAddClick() {
      this.formData = {
        Cod: '', Nume: '', Client: false, Furnizor: false, Editabil: false,
        CategorieContabilaDefaultId: null, JurnalCodInternId: null, ClasaID: '',
        UserCreare: '', DataCreare: null, UserModificare: '', DataModificare: null,
        MateriePrima: false, WwwID: null, WwwSyncedDate: null, Explicatie: '',
      };
      this.isModalVisible = true;
    },
    onSaveAdd() {
      this.formData.ClasaID = this.ClasaID;
      if (!this.formData.Nume || this.formData.Nume.trim() === '') {
        notify('Completați câmpul obligatoriu "Nume"!', 'error', 1000);
        return;
      }
      if (!this.formData.Cod || this.formData.Cod.trim() === '') {
        notify('Completați câmpul obligatoriu "Cod"!', 'error', 1000);
        return;
      }
      const body = this.formData;
      PRO_Categorii.save(body).then(() => {
        this.isModalVisible = false;
        notify('Datele au fost salvate cu succes!', 'success', 1000);
        this.formData = {
          Cod: '', Nume: '', Client: false, Furnizor: false, Editabil: false,
          CategorieContabilaDefaultId: null, JurnalCodInternId: null, ClasaID: '',
          UserCreare: '', DataCreare: null, UserModificare: '', DataModificare: null,
          MateriePrima: false, WwwID: null, WwwSyncedDate: null, Explicatie: '',
        };
        this.createODataContext(this.ClasaID);
      }).catch((error) => {
        console.error(error);
        notify('Datele exista deja!', 'error', 1000);
      });
    },
    onCancel() {
      this.isModalVisible = false;
    },
    setDeleteConfirmationMessage() {
      const dataGrid = this.$refs.dataGridRef?.instance;
      dataGrid.option('editing', {
        allowUpdating: true,
        allowDeleting: true,
        mode: 'popup',
        texts: {
          confirmDeleteMessage: this.deleteConfirmationMessage,
          confirmDeleteTitle: "Confirmare Ștergere",
        }
      });
    },
    onClick() {
      this.isModalVisible = true;
    },
    onRefreshClick() {
      this.createODataContext(this.ClasaID);
      notify('Datele au fost actualizate cu succes!', 'success', 1000)
    },
    onSaveEdit() {
      const savePromise = this.$refs.dataGridRef?.instance?.saveEditData();
      savePromise
        .then(() => { notify('Datele au fost salvate cu succes!', 'success', 1000); })
        .catch(() => { notify('Eroare la salvarea datelor!', 'error', 1000); });
    },
    onCancelEdit() {
      this.$refs.dataGridRef.instance?.cancelEditData();
    },
    onRowRemoving(e) {
      e.cancel = new Promise((resolve) => {
        notify('Datele au fost șterse cu succes!', 'success', 1000);
        resolve(false);
      });
    },
    onRowClick(e) {
      const row = e.data
      if (row?.Id) {
        this.focusedRowKey = row.Id
        this.$router.push({ name: 'Produse', query: { CategorieId: row.Id, ClasaID: this.ClasaID } })
      }
    },
  },
  mounted() {
    this.createODataContext();
    this.setDeleteConfirmationMessage();
    loadMessages({ "ro": { "Yes": "Da", "No": "Nu" } });
    locale('ro');
  },
});
</script>

<style scoped lang="scss">
.categorii-panel {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  background: #fff;
}
.categorii-grid-container {
  flex: 1;
  min-height: 0;
  overflow: hidden;
}
:deep(.dx-datagrid-header-panel) {
  padding-top: 8px;
  padding-bottom: 8px;
}
:deep(.dx-datagrid-rowsview .dx-row > td) {
  padding-top: 4px;
  padding-bottom: 4px;
  font-size: 13px;
}
:deep(.dx-datagrid-headers .dx-row > td) {
  padding-top: 6px;
  padding-bottom: 6px;
  font-size: 12px;
}
.categorii-header {
  display: flex;
  align-items: center;
  padding: 7px 14px;
  min-height: 44px;
  background: linear-gradient(90deg, #ff6a4a, #ff2c21);
  color: white;
  flex-shrink: 0;
}
.header-text {
  display: flex;
  flex-direction: column;
}
.panel-title {
  font-size: 15px;
  font-weight: 700;
  line-height: 1.2;
}
.panel-subtitle {
  font-size: 12px;
  opacity: 0.85;
  margin-top: 1px;
}
</style>
